import { Add, GridView } from "@mui/icons-material";
import { Button, Grid, IconButton } from "@mui/material";
import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { PopupModal } from "../../Components/Modal/Modals";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import EditLicense from "./DesignerLicense/EditLicense";

const Designers = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span> {path} </span>
                </div>
                <div>
                    <Link to="/dashboard/designers/create" style={{margin:"0px 5px"}}>
                        <ButtonTable startIcon={<Add />}>
                            New Designer
                        </ButtonTable>
                    </Link>
                    <Link to="/dashboard/designers/create/license" style={{margin:"0px 5px"}}>
                        <ButtonTable startIcon={<Add />}>
                            New License
                        </ButtonTable>
                    </Link>
                </div>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default Designers;
